export const trustAvatars = [
  {
    name: "Anna",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
  },
  {
    name: "Marek",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150"
  },
  {
    name: "Piotr",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150"
  },
  {
    name: "Tomasz",
    image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=150"
  },
  {
    name: "Kasia",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150"
  }
] as const;